"use strict";
exports.__esModule = true;
exports.RateHelperService = void 0;
var http_1 = require("../../core/http");
var rate_api_1 = require("./rate.api");
var operators_1 = require("rxjs/operators");
var fetchRate$;
var fetchRate = function (sessionId) {
    if (!fetchRate$) {
        fetchRate$ = http_1.Http.get(rate_api_1.RateApi.get(sessionId)).pipe(operators_1.share(), operators_1.map(function (res) { return res.rates; }));
    }
    return fetchRate$;
};
var getSingleRate = function (sessionId, rateId) {
    return http_1.Http.get(rate_api_1.RateApi.getRate(sessionId, rateId)).pipe(operators_1.share(), operators_1.map(function (res) { return res; }));
};
var resetCacheFetchRate = function () { return fetchRate$ = null; };
exports.RateHelperService = { fetchRate: fetchRate, resetCacheFetchRate: resetCacheFetchRate, getSingleRate: getSingleRate };
//# sourceMappingURL=rate-helper.service.js.map